





















































































import { Component } from 'vue-property-decorator';
import {CardForm} from '@/components/bwaff';
import Form, {Send} from '@/components/form-base';
import Api from '@/services';
import VueRecaptcha from 'vue-recaptcha';
import {mixins} from 'vue-class-component';
import Recaptcha from '@/views/pages/mixins/recaptcha-mixin.vue';

@Component({
  components: {
    CardForm,
    VueRecaptcha
  }
})
export default class LoginSupportForm extends mixins<Recaptcha,Form>(Recaptcha,Form) {
  error: boolean = false;
  error_message: string = '';
  rememberMe: boolean = true;
  edit: boolean = true;
  show_password: boolean = false;
  userId: string = '';
  password: string = '';

  created() {
    this.userId = this.$route.query.userId.toString();
  }

  @Send()
  submit() {
    return Api.loginSupport({
      userId: this.userId,
      password: this.password,
      recaptchaResponse: this.recaptchaResponse,
    })
    .catch((err) => {
      const {status} = err.response;
      this.showRecaptcha && (this.$refs.recaptcha  as any).reset();
      this.recaptchaResponse = '';

      if(status===401 || status===422){
        this.showRecaptcha = true;
      }

      if(status===400 || status===401 || status===403 || status===429){
        this.error = true;
        this.password = '';
      }

      if(status===429){
        this.error_message = this.t('You’ve reached the maximum login attempts. Try again in 60 minutes.');
      }

      if(status===400 || status===401 || status===403){
        this.error_message = this.t('Email / Password is invalid');
      }

    });
  }
}
